export const SMS_NOTIFICATIONS_PATIENT_CONSENT_LANGUAGE =
  "I agree to receive SMS message updates about my appeal as outlined in the Terms of Service";

export const SMS_NOTIFICATIONS_REFERRAL_CONSENT_LANGUAGE =
  "I agree to receive SMS messages, including informational and marketing texts, from Claimable regarding my appeal. Message & data rates may apply. Reply STOP to opt out. Consent is not a condition of purchase. See Terms & Privacy Policy.";

export const SMS_NOTIFICATIONS_TRANSACTIONAL_CONSENT_LANGUAGE =
  "By opting in, I agree to receive important text message updates about my appeal from Claimable, such as status changes and appeal support. Messaging frequency varies.";

export const SMS_NOTIFICATIONS_MARKETING_CONSENT_LANGUAGE =
  "By opting in, I agree to receive marketing text messages from Claimable. I understand that I may receive up to 10 messages a month.";
